import emitUserEvent from './emitUserEvent'
import {UserEventsMap} from './UserEventsMap'
import isNeedToSendUserEvents from "./checks/isNeedToSendUserEvents";

let initialized = false
const AT_EVENT_USER_NAME = 'atevent'

export default function initUserEventListeners() {
    if (!isNeedToSendUserEvents()) return
    if (initialized) return

    document.addEventListener("visibilitychange", (event) => {
        if (document.visibilityState === "visible") {
            emitUserEvent(UserEventsMap.PAGE_VISIBLE)
        } else if (document.visibilityState === "hidden") {
            emitUserEvent(UserEventsMap.PAGE_HIDDEN)
        }
    })

    window.addEventListener("message", (event) => {
        if (event.data[AT_EVENT_USER_NAME]) {
            emitUserEvent(event.data[AT_EVENT_USER_NAME].event, event.data[AT_EVENT_USER_NAME].params)
        }
    })

    initialized = true
}



// WEBPACK FOOTER //
// ./web/js/userEvents/initUserEventListeners.js